'use strict';

var _extends = Object.assign || function (target) {
  for (var source, i = 1; i < arguments.length; i++) {
    for (var key in source = arguments[i], source) {
      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
  }

  return target;
},
    _createClass = function () {
  function defineProperties(target, props) {
    for (var descriptor, i = 0; i < props.length; i++) {
      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
  };
}(),
    _react = require('react'),
    _react2 = _interopRequireDefault(_react),
    _propTypes = require('prop-types'),
    _propTypes2 = _interopRequireDefault(_propTypes),
    _styledComponents = require('styled-components'),
    _styledComponents2 = _interopRequireDefault(_styledComponents),
    _reactPopper = require('react-popper'),
    _themes = require('../../themes'),
    _propTypes3 = require('../../propTypes'),
    _componentTheme = require('./componentTheme'),
    _componentTheme2 = _interopRequireDefault(_componentTheme);

Object.defineProperty(exports, '__esModule', {
  value: !0
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    0 <= keys.indexOf(i) || Object.prototype.hasOwnProperty.call(obj, i) && (target[i] = obj[i]);
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
}

function _possibleConstructorReturn(self, call) {
  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
  return call && ('object' == typeof call || 'function' == typeof call) ? call : self;
}

function _inherits(subClass, superClass) {
  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
}

var Styled = {
  div: {}
};
Styled.div.popper = _styledComponents2.default.div.withConfig({
  displayName: 'PopoverContent__popper'
})(['display:block;max-width:100%;height:100%;padding:0;overflow:hidden;background-color:', ';border-color:', ';border-width:', ';border-style:', ';border-radius:', ';box-shadow:', ';'], (0, _themes.getStyle)('Popover_backgroundColor'), (0, _themes.getStyle)('Popover_borderColor'), (0, _themes.getStyle)('Popover_borderWidth'), (0, _themes.getStyle)('Popover_borderStyle'), (0, _themes.getStyle)('Popover_borderRadius'), (0, _themes.getStyle)('Popover_boxShadow'));

var PopoverContent = function (_Component) {
  function PopoverContent() {
    return _classCallCheck(this, PopoverContent), _possibleConstructorReturn(this, (PopoverContent.__proto__ || Object.getPrototypeOf(PopoverContent)).apply(this, arguments));
  }

  return _inherits(PopoverContent, _Component), _createClass(PopoverContent, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          modifiers = _props.modifiers,
          placement = _props.placement,
          themeProp = _props.theme,
          otherProps = _objectWithoutProperties(_props, ['children', 'modifiers', 'placement', 'theme']),
          theme = (0, _componentTheme2.default)(themeProp);

      return _react2.default.createElement(_reactPopper.Popper, {
        modifiers: modifiers,
        placement: placement
      }, function (_ref) {
        var popperProps = _ref.popperProps,
            otherWrapperProps = _ref.otherWrapperProps,
            wrapperProps = _extends({}, popperProps, otherWrapperProps);

        return _react2.default.createElement('div', _extends({}, wrapperProps, otherProps), _react2.default.createElement(Styled.div.popper, {
          theme: theme
        }, children));
      });
    }
  }]), PopoverContent;
}(_react.Component);

PopoverContent.propTypes = {
  children: _propTypes2.default.node.isRequired,
  hidden: _propTypes2.default.bool,
  modifiers: _propTypes2.default.object,
  placement: _propTypes2.default.oneOf(['auto', 'top', 'right', 'bottom', 'left', 'auto-start', 'top-start', 'right-start', 'bottom-start', 'left-start', 'auto-end', 'top-end', 'right-end', 'bottom-end', 'left-end']),
  theme: _propTypes3.themeShape
}, PopoverContent.defaultProps = {
  theme: (0, _themes.createTheme)()
}, PopoverContent.displayName = 'PopoverContent';
var PopoverContentWithTheme = (0, _themes.withTheme)(PopoverContent);
PopoverContentWithTheme.WrappedComponent = PopoverContent, exports.default = PopoverContentWithTheme;